export default {
  allJournalEntries: (state) => state.journalEntries,
  allAccountPayablesAC: (state) => state.accountPayablesAC,
  journalEntriesLoadingStatus: (state) => state.journalEntriesLoadingStatus
}
